import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import parse from 'html-react-parser'
import { useDialogSelector } from '../store/selectors/dialogSelector'
import { ACTIONS } from '../_config'
import Button from '../elements/button'
import Text from '../elements/Typo/Text'
import Icon from './icons'
const Dialog: React.FC = () => {
    const { t } = useTranslation()
    const dispach = useDispatch()
    const dialog: any = useDialogSelector()
    const dialogModal: any = useRef()

    useEffect(() => {
        if (dialog === null) {
            dialogModal.current?.close()
        } else {
            dialogModal.current?.showModal()
        }
    }, [dialog])

    const close = () => {
        dialogModal.current?.close()
    }
    return (
        <dialog
            ref={dialogModal}
            className="modal"
            onClose={() => {
                dispach({ type: ACTIONS.DIALOG, payload: null })
            }}
        >
            <div className="modal-box">
                {dialog?.dialog == 'confirm' && (
                    <>
                        {dialog?.type == 'delete' && (
                            <>
                                <p className="font-bold text-center text-[1.333rem] leading-8">{dialog.title}</p>
                                <p className="py-4 text-center whitespace-break-spaces text-[0.8rem] leading-[1.2]">{parse(dialog.message)}</p>
                                {dialog.warning && (
                                    <div className="mb-8 bg-[#FFE9D9] rounded-[0.333rem] text-center overflow-hidden px-4 py-2">
                                        <div className="flex items-center text-[#F23F44] justify-center mb-1">
                                            <Icon name="warning" />
                                            <Text size="xl" className="!text-[#F23F44] font-bold">
                                                {t('Warning')}
                                            </Text>
                                        </div>
                                        <Text size="xl" className="text-[#BC4C2E]">
                                            {parse(dialog.warning)}
                                        </Text>
                                    </div>
                                )}

                                {dialog.error && (
                                    <div className="mb-8 bg-[#FFE9D9] rounded-[0.333rem] text-center overflow-hidden px-4 py-2">
                                        <div className="flex items-center text-[#F23F44] justify-center mb-1">
                                            <Icon name="warning" />
                                            <Text size="xl" className="!text-[#F23F44] font-bold">
                                                {t('Error')}
                                            </Text>
                                        </div>
                                        <Text size="xl" className="text-[#BC4C2E]">
                                            {parse(dialog.error)}
                                        </Text>
                                    </div>
                                )}
                                <div className="flex justify-center gap-2">
                                    {dialog.cancelButton !== false && (
                                        <Button
                                            size="sm"
                                            theme="tertiary"
                                            className="border"
                                            onClick={() => {
                                                dialog?.onCancel?.()
                                                close()
                                            }}
                                        >
                                            <Icon name="close" size={'1rem'} />

                                            {dialog.cancelButtonLabel ?? t('No, Cancel')}
                                        </Button>
                                    )}

                                    <Button
                                        size="sm"
                                        theme="secondary"
                                        onClick={() => {
                                            dialog?.onConfirm?.()
                                            close()
                                        }}
                                    >
                                        <Icon name="check" size={1} />
                                        {dialog.confirmButtonLabel ?? t('Yes, Delete')}
                                    </Button>
                                </div>
                            </>
                        )}
                    </>
                )}

                {dialog?.dialog == 'share' && (
                    <>
                        {dialog?.type == 'link' && (
                            <>
                                <p className="font-bold text-center text-[1.333rem] leading-8">{dialog.title}</p>
                                <p className="py-4 text-center">{parse(dialog.message)}</p>
                                <div className="flex items-center my-3 h-[3.042rem] bg-[#f4f4f4] border border-[#c1c1c1] rounded-[0.333rem] p-2">
                                    <Text size="xl" className="text-[0.75rem] text-[#808E96]">
                                        {dialog.link}
                                    </Text>
                                </div>
                            </>
                        )}
                    </>
                )}
                {dialog?.dialog == 'successExperiment' && (
                    <>
                        <div className="flex justify-center -mt-[3rem]">
                            <img alt={t('success')} src="/assets/images/success.gif" className="w-[14rem]" />
                        </div>

                        <div className="text-center font-semibold -mt-[2rem]">
                            <Text size="lg" className="mb-4">
                                {t('Experiment Submitted Successfully')}
                            </Text>
                            <Text size="lg" className="mb-4">
                                {t('Please proceed with Execution of your experiment!')}
                                <br />
                                {t('Once it is completed, come back here to check the results')}
                            </Text>
                        </div>

                        <div className="flex justify-center gap-2">
                            <Button
                                theme="secondary"
                                size="sm"
                                onClick={() => {
                                    dialog.onButtonClick()
                                    close()
                                }}
                            >
                                <Icon name="eye" />
                                {t('Back to Home')}
                            </Button>
                        </div>
                    </>
                )}
                {dialog?.dialog == 'successRecurring' && (
                    <>
                        <div className="flex justify-center -mt-[3rem]">
                            <img alt={t('success')} src="/assets/images/success.gif" className="w-[14rem]" />
                        </div>

                        <div className="text-center font-semibold -mt-[2rem]">
                            <Text size="lg" className="mb-4">
                                {t('Design Data Submitted Successfully')}
                            </Text>
                            <Text size="lg" className="mb-4">
                                {t('Please proceed with Execution of your experiment!')}
                                <br />
                                {t('Once it is completed, come back here to check the results')}
                            </Text>
                        </div>

                        <div className="flex justify-center gap-2">
                            <Button
                                theme="secondary"
                                size="sm"
                                onClick={() => {
                                    dialog.onButtonClick()
                                    close()
                                }}
                            >
                                <Icon name="eye" />
                                {t('Back to Recurring Experiments')}
                            </Button>
                        </div>
                    </>
                )}
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('Close')}</button>
            </form>
        </dialog>
    )
}

export default Dialog
